import { initStickyHeader } from './joinFlow/stickyHeader';
import {
  toggleRebateTier,
  toggleRebateDisclaimer,
  toggleRebateNext,
  toggleMedicareCardColour,
  toggleAdb,
  toggleOtherFields,
  toggleTransferFields,
  togglePaymentFrequency
} from './joinFlow/toggles'

import {
  validatePromo,
  validateMaxDate,
  validateConcessionDate,
  validateCCDate,
  validateMedicare,
  validateVisaCommencementDates,
  validateDob
} from './joinFlow/validation'

import {
  reloadOnBackPress,
  setHiddenAttribute,
  customHtml5PatternValidation,
  cloneBankToClaimDetails
} from './joinFlow/utils'

import {
  initSelect2,
  initSelectableEmptyOption,
  initBsbValidation,
  initDependants,
  initReviewFields,
  initGetQuoteFunction
} from './joinFlow/init'

import { getPriceByDateChange } from './priceChange' 

export const render = () => {
  const joinLink = document.getElementById("proceed-to-join")

  if (joinLink !== null) {
    joinLink.setAttribute("href", "#")
  }

  const form = document.querySelector<HTMLFormElement>("form[data-join-step]")
  const step = form?.getAttribute("data-join-step")
  const isOverseas = window.Westfund.IsOverseas
  
  if (step === "membership-status") {
    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]')
    const selectionNote = form.querySelector<HTMLDivElement>("div.selection-note")
    
    const updateFormState = () => {
      const checked = form.querySelector<HTMLInputElement>("input:checked")
      const isExistingChecked = (checked)
        ? checked.value === "existing"
        : false;
      const hideMessage = checked === null || checked.value === "new"
      const preventNext = checked === null || isExistingChecked

      setHiddenAttribute(selectionNote, hideMessage)
      submitBtn.disabled = preventNext;

      if (isExistingChecked) {
        submitBtn.classList.add('hidden')
      } else {
        submitBtn.classList.remove('hidden')
      }
    }

    form.querySelectorAll("input")?.forEach((elem) => {
      elem.addEventListener("change", updateFormState)
    })

    updateFormState()
  }

  if (step == "details") {
    toggleOtherFields(form)
    if (isOverseas) {
      initSelect2()
    } else {
      toggleAdb(form)
    }
  }

  if (step === "tell-us-about-you") {
    toggleOtherFields(form)
    validateDob(form, 18, null, "You must be 18 or over to take out health insurance with Westfund.",  getPriceByDateChange)

    if (isOverseas) {
      validateVisaCommencementDates(form)
      initSelectableEmptyOption(form)
    }
  }

  if (step == "tell-us-about-you-contact") {
    toggleOtherFields(form)
  }

  if (step === "tell-us-about-you-dependents") {
    initDependants()
    reloadOnBackPress()
  }

  if (step == "your-cover-rebate") {
    toggleOtherFields(form)
    toggleRebateTier(form)
    toggleRebateDisclaimer(form)
    toggleMedicareCardColour(form)
    validateCCDate(form)
    validateMedicare(form)
    toggleRebateNext(form)
  }

  if (step == "your-cover-transfer") {
    toggleOtherFields(form)
    toggleTransferFields(form)
  }

  if (step == "your-cover-lhc") {
    toggleOtherFields(form)
  }

  if (step == "your-cover-concession") {
    toggleOtherFields(form)
    validateConcessionDate(form)
  }

  if (step == "pay-promo") {
    validatePromo(form)
  }

  if (step == "pay-start") {
    toggleOtherFields(form);
    validateMaxDate(form, getPriceByDateChange);
  }

  if (step == "pay-details") {
    toggleOtherFields(form);
    togglePaymentFrequency(form);
    initBsbValidation(form);
    validateCCDate(form);
    if (isOverseas) {
       // initGetQuoteFunction(form)
    } else {
      cloneBankToClaimDetails(form)
    }
  }

  if (step == "overseas-purpose") {
    toggleOtherFields(form)
  }

  const editDetailsModalForm = document.querySelector<HTMLFormElement>("form.details-modal-form")

  if (isOverseas && editDetailsModalForm) {
    initSelect2()
  } 

  // generic pattern check {
  customHtml5PatternValidation(form);

  window.addEventListener("pageshow", initReviewFields)
  initReviewFields()
}

initStickyHeader()

document.querySelectorAll("[data-binded-to]").forEach(elem => {
  const bindedToElem = document.querySelector(elem.dataset.bindedTo);
  const initialText = bindedToElem.innerText;
  elem.addEventListener('change', function(e){
    if(bindedToElem){
      if(e.target.value){
        bindedToElem.innerHTML = e.target.value;
      }
      else{
        bindedToElem.innerHTML = initialText;
      }
    }
  })
})